import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { FolderLabel } from "../FolderLabel";
import { PlanNameList } from "../PlanNameList";
import { TableHeaderRow } from "../TableHeaderRow";
import { UNASSIGNED_AXIS_KEY } from "../constants";
import type { FoldersPerRowProps } from "./types";

export const FoldersPerRow = ({ table, planNameById }: FoldersPerRowProps) => {
  const { t } = useTranslation();

  const { rows, columns, floorPlanIdsByCell, planCountByRow } = table;

  return (
    <>
      <TableHeaderRow table={table} />
      {rows.values.map((rowValue, rowIndex) => (
        <div
          key={rowValue?.code ?? UNASSIGNED_AXIS_KEY}
          className={clsx(
            "col-span-full grid min-h-11 grid-cols-subgrid items-center rounded-lg border py-1.5 text-sm font-medium",
            rowValue === null
              ? "border-transparent text-gray-700"
              : "border-blue-300 bg-blue-50 text-blue-700",
          )}
        >
          {rowValue === null ? (
            <span className="px-3">
              {t("smartSurveyor.folders.suggestion.notAssigned")}
            </span>
          ) : (
            <FolderLabel
              name={rowValue.name}
              fileCode={rowValue.fileCode}
              planCount={planCountByRow[rowIndex]}
              iconSize={16}
              className="px-3"
            />
          )}
          {columns.values.map((columnValue, columnIndex) => (
            <PlanNameList
              key={columnValue?.code ?? UNASSIGNED_AXIS_KEY}
              floorPlanIds={floorPlanIdsByCell[rowIndex][columnIndex]}
              planNameById={planNameById}
              className="px-3"
            />
          ))}
        </div>
      ))}
    </>
  );
};
